import { cva } from "class-variance-authority";
export const sizes = ["2xs", "xs", "sm", "md", "lg", "xl", "2xl"];
export const shapes = ["circle", "square"];

export const variants = cva(
    [
        "inline-flex",
        "items-center",
        "justify-center",
        "select-none",
        "shrink-0",
        "overflow-hidden",
        "transition",
        "duration-400",
        "ease-out",
        "border",
        "md:border",
    ],
    {
        variants: {
            size: {
                "2xs": [
                    "w-6",
                    "h-6",
                    "text-style-xs",
                    "[&_i]:w-3.5",
                    "[&_i]:h-3.5",
                ],
                xs: [
                    "w-8",
                    "h-8",
                    "text-style-xs",
                    "[&_i]:w-3.5",
                    "[&_i]:h-3.5",
                ],
                sm: ["w-9", "h-9", "text-style-sm", "[&_i]:w-5", "[&_i]:h-5"],
                md: [
                    "w-10",
                    "h-10",
                    "text-style-base",
                    "[&_i]:w-5",
                    "[&_i]:h-5",
                ],
                lg: [
                    "w-11",
                    "h-11",
                    "text-style-base",
                    "[&_i]:w-6",
                    "[&_i]:h-6",
                ],
                xl: ["w-12", "h-12", "text-style-lg", "[&_i]:w-6", "[&_i]:h-6"],
                "2xl": [
                    "w-14",
                    "h-14",
                    "text-style-xl",
                    "[&_i]:w-7",
                    "[&_i]:h-7",
                ],
            },
            shape: {
                circle: ["rounded-full"],
            },
            variant: {
                building: ["text-white", "font-semibold"],
            },
            color: {
                "blue-light": ["border-utility-blue-light-500"],
                blue: ["border-utility-blue-500"],
                "blue-dark": ["border-utility-blue-dark-500"],
                indigo: ["border-utility-indigo-500"],
                purple: ["border-utility-purple-500"],
                fuchsia: ["border-utility-fuchsia-500"],
                pink: ["border-utility-pink-500"],
                orange: ["border-utility-orange-500"],
                "orange-dark": ["border-utility-orange-dark-500"],
                yellow: ["border-utility-warning-500"],
            },
        },
        compoundVariants: [
            {
                size: ["2xs"],
                shape: "square",
                class: ["rounded-md"],
            },
            {
                size: ["xs"],
                shape: "square",
                class: ["rounded-lg"],
            },
            {
                size: "sm",
                shape: "square",
                class: ["rounded-xl"],
            },
            {
                size: "md",
                shape: "square",
                class: ["rounded-xl"],
            },
            {
                size: "lg",
                shape: "square",
                class: ["rounded-xl"],
            },
            {
                size: "xl",
                shape: "square",
                class: ["rounded-[14px]"],
            },
            {
                size: "2xl",
                shape: "square",
                class: ["rounded-2xl"],
            },
            {
                variant: "default",
                active: false,
                class: [
                    "text-alpha-black-80",
                    "bg-alpha-white-20",
                    "border-none",
                    "hover:fg-primary",
                    "group-hover:fg-primary",
                    "group-hover:border-none",
                    "data-[open=true]:fg-primary",
                    "hover:bg-primary",
                    "group-hover:bg-alpha-white-20",
                    "data-[open=true]:bg-alpha-white-50",
                ],
            },
            {
                variant: "default",
                active: true,
                class: ["fg-primary", "bg-alpha-white-20", "border-none"],
            },
            {
                variant: "building",
                active: false,
                class: [
                    "hover:bg-alpha-white-70",
                    "group-hover:bg-alpha-white-70",
                    "hover:border-2",
                    "group-hover:border-2",
                    "hover:shadow-md",
                    "group-hover:shadow-md",
                ],
            },
            {
                variant: "building",
                color: "blue-light",
                active: true,
                class: ["bg-utility-blue-light-500"],
            },
            {
                variant: "building",
                color: "blue",
                active: true,
                class: ["bg-utility-blue-500"],
            },
            {
                variant: "building",
                color: "blue-dark",
                active: true,
                class: ["bg-utility-blue-dark-500"],
            },
            {
                variant: "building",
                color: "indigo",
                active: true,
                class: ["bg-utility-indigo-500"],
            },
            {
                variant: "building",
                color: "purple",
                active: true,
                class: ["bg-utility-purple-500"],
            },
            {
                variant: "building",
                color: "fuchsia",
                active: true,
                class: ["bg-utility-fuchsia-500"],
            },
            {
                variant: "building",
                color: "pink",
                active: true,
                class: ["bg-utility-pink-500"],
            },
            {
                variant: "building",
                color: "orange",
                active: true,
                class: ["bg-utility-orange-500"],
            },
            {
                variant: "building",
                color: "orange-dark",
                active: true,
                class: ["bg-utility-orange-dark-500"],
            },
            {
                variant: "building",
                color: "yellow",
                active: true,
                class: ["bg-utility-warning-500"],
            },
        ],
        defaultVariants: {
            variant: "default",
            size: "sm",
            shape: "circle",
            color: "default",
            active: false,
        },
    }
);
